import * as React from 'react';
import { classNames } from '@wix/answers-lib';
export const supportedVideoRegex = {
    urlYoutube: /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))([?]+(.+))*/ig,
    urlVimeo: /https?:\/\/(www\.)?vimeo.com\/(\d+)([?]+(.+))*/,
    isYoutube: /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/,
    isVimeo: /player.vimeo.com\/(.+)*/
};
const urlFix = (url) => {
    let fixedUrl = url;
    if (url) {
        if (url.match(supportedVideoRegex.urlYoutube)) {
            fixedUrl = url.replace(supportedVideoRegex.urlYoutube, '//www.youtube.com/embed/$1' + '?wmode=opaque&enablejsapi=1&' + '$3');
        }
        else if (url.match(supportedVideoRegex.urlVimeo)) {
            fixedUrl = url.replace(supportedVideoRegex.urlVimeo, '//player.vimeo.com/video/$2' + '?api=1&' + '$4');
        }
    }
    return fixedUrl;
};
export class VideoComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    render() {
        const props = this.props;
        const videoUrl = urlFix(props.value.url);
        const onRefSet = (ref) => this.iframe = ref;
        const videoContainerStyle = {
            textAlign: props.value.align || 'center'
        };
        return (React.createElement("div", { className: classNames('component video-component', props.direction), "data-component-type": 'video' },
            React.createElement("div", { className: `video-container`, style: videoContainerStyle },
                React.createElement("iframe", { src: videoUrl, ref: onRefSet, allowFullScreen: true }))));
    }
}
